module.exports = __webpack_public_path__ + "img/forget-pwd-bg.b9d84ab.png";